import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PageNotFound = () => {
  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      {/* Header */}
      <div
        className="text-white py-0 px-4 d-flex align-items-center"
        style={{ backgroundColor: "#040c4b" }}
      >
        <div className="logo-wrapper">
          <img
            className=""
            src="/AcademyLogoBlue.png"
            style={{
              filter: "invert(1) grayscale(1) brightness(2)",
              width: "55px",
              height: "auto",
            }}
            alt="Al Hilal Academy Logo"
          />
        </div>
        <h5 className="mb-0 fw-bold text-white">Al Hilal Academy</h5>
      </div>

      {/* Main Content */}
      <main className="flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center">
        <h1
          className="display-1 fw-bold"
          style={{ fontSize: "10rem", color: "#040c4b" }}
        >
          404
        </h1>

        <p className="fs-4 text-dark">Ooops!...Page not found.</p>

        {/* <a href="/" className="btn btn-primary px-4 py-2 mt-3">
          Go Back
        </a> */}
      </main>
    </div>
  );
};

export default PageNotFound;
